import React, { Component } from "react";
import Firebase from "firebase";
import Moment from "moment";
import "firebase/functions";
import Connector from "../../data/Connector";
import HelperCal from "../../helper/Calendar";
import HelperClients from "../../helper/Clients";
import Message from "../../components/Message";
import Textarea from "../../components/Form/textarea";
import InputToggle from "../../components/Form/toggle";
import * as ROUTES from "../../constants/routes";
import { Link, withRouter } from "react-router-dom";
import EventEmitter from "../../helper/Emitter";
import { AuthUserContext, withAuthorization } from "../../components/Session";

import { withTranslation } from "react-i18next";
import lang from "i18next";

class MemberRunningPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      item: null,
      program: null,
      view: "select",
      clients: global.clients,
      client: null,
      back: "/" + global.uid + "/training/sessions",
      hrs: [],
      min: [],
      link: "",
      current: 0,
      results: 0,
      round: 1,
      interval: 0,
      intmax: 0,
      timer: "getready",
      end: 0,
      pos: global.timerStart,
      counter: null,
      volume: true,
      // Results
      valAR1: [],
      valAR2: [],
      notes: "",
      notesSimple: [],
      valueSimple: [],
      scaledSimple: [],
      ex: [],
      // Overlays
      margin: 0,
      showOverlayPause: false,
      hiddenPause: "hidden",
      paused: false,
      showOverlayEnergy: false,
      hiddenEnergy: "hidden",
      showOverlayAbort: false,
      hiddenAbort: "hidden",
      showOverlayNotes: false,
      hiddenNotes: "hidden",
      energy: [],
      levels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      energyShown: false,
      best: null,
      bestGroup: null,
    };
  }

  componentDidMount() {
    var arr = this.props.location.pathname.split("/");
    var id = arr[arr.length - 3];
    var sess = arr[arr.length - 1];
    document.title =
      lang.t("header:title.session") + " - " + global.userBusiness;

    if (id !== "running" && id !== "member") {
      global.uid = id;
    }
    Connector.setUser();

    EventEmitter.subscribe("userLoaded", (event) => this.checkSpace());
    EventEmitter.subscribe("clientLoaded", (event) => this.configureData());
    EventEmitter.subscribe("sessionsLoaded", (event) => this.configureData());
    EventEmitter.subscribe("trainingLoaded", (event) => this.configureData());

    var tmp1 = [];
    for (var i = 0; i < 60; i++) {
      if (i < 10) {
        tmp1.push("0" + i);
      } else {
        tmp1.push(i);
      }
    }

    this.setState({
      min: tmp1,
      sec: tmp1,
      session: sess,
    });

    var audio1 = new Audio("/audio/audio1sec.mp3");
    audio1.preload = "auto";
    var audio2 = new Audio("/audio/audiostart.mp3");
    audio2.preload = "auto";
    var audio3 = new Audio("/audio/audioend.mp3");
    audio3.preload = "auto";
    this.configureData();
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe("userLoaded", () => {});
    EventEmitter.unsubscribe("clientLoaded", () => {});
    EventEmitter.unsubscribe("sessionsLoaded", () => {});
    EventEmitter.unsubscribe("trainingLoaded", () => {});
  }

  checkSpace() {
    if (global.uid === "") {
      this.props.history.push(ROUTES.LOADING);
    } else {
      var found = false;
      for (var item of global.userStaff) {
        if (item.id === global.uid) {
          found = true;
        }
      }
      if (found) {
        document.title =
          lang.t("header:title.session") + " - " + global.userBusiness;
        this.configureData();
      } else {
        this.props.history.push(ROUTES.LOADING);
      }
    }
  }

  configureData() {
    var arr = this.props.location.pathname.split("/");
    var id = arr[arr.length - 1];
    var back = "/" + global.uid + "/training/sessions";
    var item = null;
    var program = null;

    for (var session of global.sessionsTraining) {
      if (session.id === id) {
        item = session;
        program = session.program[0];
        back = "/" + global.uid + "/training/program/" + session.program[0].id;
      }
    }

    if (item === null && global.sessions) {
      for (var s of global.sessions) {
        if (s.id === id) {
          item = s;
          program = s.program[0];
          back = "/" + global.uid + "/training/program/" + s.program[0].id;
        }
      }
    }

    this.setState(
      {
        id: id,
        clients: global.clients,
        clientsList: global.clients,
        back: back,
        item: item,
        program: program,
        best: global.clientBest,
      },
      () => {
        if (
          this.state.current === 0 &&
          this.state.item !== null &&
          !this.state.energyShown
        ) {
          this.setState({
            energyShown: true,
          });
          setTimeout(() => {
            this.showOverlayEnergy();
          }, 500);
        }
      },
    );
  }

  // Configuration ------------------------------------------------------------

  getSessionName() {
    var label = lang.t("header:title.session") + " - ";
    if (this.state.item !== null) {
      label =
        lang.t("calendar:label.training") +
        " - " +
        Moment(this.state.item.data.date, "DD/MM/YYYY HH:mm").format("hh:mm a");
    }
    return label;
  }

  getSetsName(item) {
    var label = lang.t("training:prog.set");
    if (item.exId.length > 1) {
      var prev = "";
      var multiple = true;
      for (var ex of item.exId) {
        if (ex !== prev && prev !== "") {
          label = lang.t("training:prog.superset");
          multiple = false;
        }
        if (ex === prev && prev !== "") {
          label = lang.t("training:prog.dropset");
        }
        prev = ex;
      }
      if (multiple) {
        label = lang.t("training:prog.dropset");
      } else {
        label = lang.t("training:prog.superset");
      }
    }
    return label;
  }

  getBlockHeader(block) {
    if (this.state.program !== null) {
      var item = block.data;
      var name = lang.t(global.proTypes[item.type]);
      var label = "";
      var s = lang.t("training:prog.rounds");
      if (
        (item.rounds === 1 && item.type !== 5) ||
        (item.cycles === 1 && item.type === 5)
      ) {
        s = lang.t("training:prog.round");
      }
      if (item.type === 0) {
        label = " - " + HelperCal.getDurationMin(item.rounds);
      }
      if (item.type === 1) {
        label = " - " + item.rounds + " " + s;

        if (item.emom) {
          label =
            " - " +
            item.rounds +
            " " +
            s +
            " " +
            lang.t("training:prog.of") +
            " " +
            HelperCal.getDurationMin(parseInt(item.exWork[0]));
        }
      }
      if (item.type === 2 || item.type === 3) {
        label = " - " + item.rounds + " " + s;
        if (item.type === 2 && item.emom) {
          if (item.exRest[0] === 0) {
            label +=
              " (" +
              HelperCal.getDurationMin(parseInt(item.exWork[0])) +
              " " +
              lang.t("training:prog.work") +
              ")";
          } else {
            label +=
              " (" +
              HelperCal.getDurationMin(parseInt(item.exWork[0])) +
              " - " +
              HelperCal.getDurationMinAlt(parseInt(item.exRest[0])) +
              ")";
          }
        }
      }
      if (item.type === 4) {
        label = " - " + item.rounds + " " + this.getSetsName(item) + "s";
        if (item.rounds === 1) {
          label = " - 1 " + this.getSetsName(item);
        }
      }
      if (item.type === 5) {
        label = " - " + HelperCal.getDurationMin(item.rounds);
        if (item.cycles > 1) {
          label =
            " - " +
            item.cycles +
            " " +
            s +
            " - " +
            lang.t("training:prog.cap") +
            ": " +
            HelperCal.getDurationMin(item.rounds);
        }
      }
      return name + " " + label;
    }
  }

  getInterval(block, index) {
    if (!block.data.emom && (block.data.type === 1 || block.data.type === 2)) {
      if (block.data.exRest[index] !== 0) {
        return (
          <span>
            <br />
            {HelperCal.getDurationMin(block.data.exWork[index])} work -{" "}
            {HelperCal.getDurationMin(block.data.exRest[index])} rest
          </span>
        );
      } else {
        return (
          <span>
            <br />
            {HelperCal.getDurationMin(block.data.exWork[index])}
          </span>
        );
      }
    }
  }

  getClient(id) {
    var client = null;
    for (var item of this.state.clients) {
      if (item.id === id) {
        client = item;
      }
    }
    return client;
  }

  getClientName(id, type) {
    var label = "";
    for (var item of this.state.clients) {
      if (item.id === id) {
        var ar = item.data.name.split(" ");
        if (type === "first") {
          label = ar[0];
        } else {
          if (ar.length > 1) {
            for (var i = 1; i < ar.length; i++) {
              label += ar[i] + " ";
            }
          }
        }
      }
    }
    return label;
  }

  getExInfo(block, index) {
    var label = "-";
    var weight = "";
    var unit1 = lang.t("training:prog.reps");
    var word = " " + lang.t("training:prog.with") + " ";
    var unit2 = block.data.exWeightType;
    if (
      block.data.exWeightType === "per" ||
      block.data.exWeightType === undefined
    ) {
      unit2 = global.spaceLbs ? "lb" : "kg";
    }
    if (block.data.exUnits !== undefined) {
      if (block.data.exUnits[index] === "dist") {
        unit1 = "m";
      }
      if (block.data.exUnits[index] === "cals") {
        unit1 = "cal";
      }
      if (block.data.exUnits[index] === "time") {
        unit1 = "s";
      }
    } else {
      if (block.data.exTool[index] === 6 || block.data.exTool[index] === 7) {
        unit1 = "m";
      }
      if (block.data.exTool[index] === 27) {
        unit1 = "cal";
      }
    }
    if (block.data.exWeightType !== undefined) {
      if (block.data.exWeightType[index] === "per") {
        word = " " + lang.t("training:prog.at") + " ";
        unit2 = "%";
      }
    }
    if (block.data.exReps[index] !== 0) {
      label = block.data.exReps[index] + " " + unit1;
    }
    if (block.data.exRepsRounds !== undefined) {
      if (
        block.data.exRepsRounds[index] !== "0" &&
        block.data.exRepsRounds[index] !== ""
      ) {
        label = block.data.exRepsRounds[index] + " " + unit1;
      }
    }
    if (block.data.exWeight[index] !== 0) {
      weight = word + block.data.exWeight[index] + " " + unit2;
    }
    if (block.data.exWeightRounds !== undefined) {
      if (
        block.data.exWeightRounds[index] !== "0.0" &&
        block.data.exWeightRounds[index] !== "" &&
        block.data.exWeightRounds[index] !== "0"
      ) {
        weight = word + block.data.exWeightRounds[index] + " " + unit2;
      }
    }
    return label + weight;
  }

  getTimerName() {
    var label = lang.t("training:running.getready");
    if (this.state.timer === "work") {
      label = lang.t("training:label.work");
      if (this.state.program.blocks[this.state.current].data.type === 3) {
        label =
          lang.t("training:label.rest") +
          "Work " +
          (this.state.interval + 1) +
          " " +
          lang.t("training:prog.of") +
          " 8";
      }
    } else if (this.state.timer === "rest") {
      label = lang.t("training:label.rest");
      if (this.state.program.blocks[this.state.current].data.type === 3) {
        label =
          lang.t("training:label.rest") +
          " " +
          (this.state.interval + 1) +
          " " +
          lang.t("training:prog.of") +
          " 8";
      }
    }
    return label;
  }

  displayTimer() {
    var label = this.state.pos;
    if (this.state.timer !== "getready") {
      var min = Math.floor(this.state.pos / 60);
      var sec = this.state.pos - min * 60;
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }
      label = min + ":" + sec;
    }
    return label;
  }

  // Timer control ------------------------------------------------------------

  startTimer() {
    if (this.state.program.blocks[this.state.current].data.type !== 4) {
      this.setState({
        view: "timer",
        timer: "getready",
        end: 0,
        pos: global.timerStart,
        round: 1,
        interval: 0,
      });
      this.counter = setInterval(this.count.bind(this), 1000);
    } else {
      this.setState({
        view: "sets",
        timer: "rest",
        round: 1,
        end: 0,
        pos: global.timerStart,
      });
    }
  }

  configureTimer() {
    var block = this.state.program.blocks[this.state.current];
    var start = 0;
    var end = 0;
    var intmax = 0;
    if (block.data.type === 0) {
      start = block.data.rounds;
    } else if (block.data.type === 1) {
      start = block.data.exWork[this.state.interval];
    } else if (block.data.type === 2) {
      start = block.data.exWork[this.state.interval];
      if (block.data.emom) {
        intmax = 1;
      } else {
        intmax = block.data.exName.length;
      }
    } else if (block.data.type === 3) {
      start = block.data.exWork[this.state.interval];
      intmax = 8;
    } else if (block.data.type === 5) {
      start = 0;
      end = block.data.rounds;
    }
    this.setState({
      timer: "work",
      pos: start,
      end: end,
      intmax: intmax,
    });
    this.counter = setInterval(this.count.bind(this), 1000);
  }

  count() {
    var tmp = this.state.pos;
    var block = this.state.program.blocks[this.state.current].data;
    if (block.type === 5 && this.state.timer === "work") {
      tmp++;
    } else {
      tmp--;
    }
    if (this.state.showOverlayPause) {
      clearInterval(this.counter);
    }

    this.setState({
      pos: tmp,
    });
    if (tmp > 0 && tmp < 4 && this.state.timer === "getready") {
      var audio1 = new Audio("/audio/audio1sec.mp3");
      if (!this.state.volume) {
        audio1.volume = 0;
      }
      audio1.play();
    }

    if (tmp === this.state.end - 1 || tmp === this.state.end + 1) {
      setTimeout(() => {
        var audio = new Audio("/audio/audioend.mp3");
        if (this.state.timer === "getready") {
          audio = new Audio("/audio/audiostart.mp3");
        }
        if (!this.state.volume) {
          audio.volume = 0;
        }
        audio.play();
      }, 950);
    }

    if (tmp === this.state.end) {
      clearInterval(this.counter);
      setTimeout(() => {
        if (this.state.timer === "getready") {
          this.configureTimer();
        } else {
          // AMRAP & For Time
          if (block.type === 0 || block.type === 5) {
            this.endTimer();
            // EMOM
          } else if (block.type === 1) {
            if (
              this.state.round === block.rounds &&
              (this.state.interval === block.exWork.length - 1 || block.emom)
            ) {
              this.endTimer();
            } else {
              if (
                (this.state.interval === block.exWork.length - 1 ||
                  block.emom) &&
                this.state.round <= block.rounds
              ) {
                var tmp = this.state.round;
                tmp++;
                this.setState({
                  pos: block.exWork[0],
                  end: 0,
                  interval: 0,
                  round: tmp,
                });
                this.counter = setInterval(this.count.bind(this), 1000);
              } else if (
                this.state.interval < block.exWork.length - 1 &&
                !block.emom &&
                this.state.round <= block.rounds
              ) {
                var tmp2 = this.state.interval;
                tmp2++;
                this.setState({
                  pos: block.exWork[tmp2],
                  end: 0,
                  interval: tmp2,
                });
                this.counter = setInterval(this.count.bind(this), 1000);
              }
            }
            // Intervals & Tabata
          } else if (block.type === 2 || block.type === 3) {
            this.configureInterval();
          } else if (block.type === 4) {
            this.setState({
              view: "sets",
              timer: "rest",
            });
          }
        }
      }, 1000);
    }
  }

  configureInterval() {
    var block = this.state.program.blocks[this.state.current].data;
    if (this.state.timer === "work") {
      var pos = block.exRest[this.state.interval];
      if (block.type === 3) {
        pos = 10;
      }
      this.setState({
        pos: pos,
        end: 0,
        timer: "rest",
      });
      if (pos === 0) {
        this.configureInterval();
      } else {
        this.counter = setInterval(this.count.bind(this), 1000);
      }
    } else {
      if (this.state.interval < this.state.intmax - 1) {
        var tmp = this.state.interval;
        tmp++;
        var pos2 = block.exWork[tmp];
        if (block.type === 3) {
          pos2 = 20;
        }
        this.setState({
          pos: pos2,
          end: 0,
          timer: "work",
          interval: tmp,
        });
        this.counter = setInterval(this.count.bind(this), 1000);
      } else {
        var tmp3 = this.state.round;
        if (this.state.round < block.rounds) {
          tmp3++;
          this.setState({
            pos: block.exWork[0],
            end: 0,
            timer: "work",
            interval: 0,
            round: tmp3,
          });
          this.counter = setInterval(this.count.bind(this), 1000);
        } else {
          this.endTimer();
        }
      }
    }
  }

  endTimer() {
    var tmp = this.state.current;
    var program = this.state.program;
    
    if (program && program.blocks && program.blocks.length > tmp) {
      var block = program.blocks[tmp];
      var updateObj = {};
      if (block.data.type === 5 && this.state.timer === "work" && this.state.pos > 0) {
        block.data.timeRes = this.state.pos;
        if (this.state.item && this.state.item.data && this.state.item.data.group && this.state.item.data.clients) {
          var tg = block.data.timeResGroup || [];
          if (tg.length === 0) {
            for (var ci = 0; ci < this.state.item.data.clients.length; ci++) {
              tg.push(this.state.pos);
            }
          }
          block.data.timeResGroup = tg;
          updateObj.timeResGroup = tg;
        } else {
          updateObj.timeRes = this.state.pos;
        }
      }
      // Auto-populate preset weights for EMOM or other blocks if empty
      if (block.data.exWeight && block.data.exWeight.length > 0) {
        if (this.state.item && this.state.item.data && this.state.item.data.group && this.state.item.data.clients) {
          if (!block.data.exResWeightGroup || block.data.exResWeightGroup.every(function(w){ return !w || w === '0' || w === '' })) {
            var nwg = [];
            for (var ei = 0; ei < block.data.exWeight.length; ei++) {
              var wstr = '';
              for (var ci2 = 0; ci2 < this.state.item.data.clients.length; ci2++) {
                wstr += '-' + (block.data.exWeight[ei] || 0);
              }
              nwg.push(wstr.substring(1));
            }
            block.data.exResWeightGroup = nwg;
            updateObj.exResWeightGroup = nwg;
          }
        } else {
          if (!block.data.exResWeight || block.data.exResWeight.every(function(w){ return !w || w === 0 })) {
            block.data.exResWeight = block.data.exWeight;
            updateObj.exResWeight = block.data.exWeight;
          }
        }
      }
      var parent = global.uidUser;
      if (this.state.item && this.state.item.data) {
        if (this.state.item.data.businessUid) {
          parent = this.state.item.data.businessUid;
        } else if (this.state.item.data.uid && this.state.item.data.uid !== global.uidUser) {
          parent = this.state.item.data.uid;
        } else if (global.uid) {
          parent = global.uid;
        }
      }
      if (this.state.item && this.state.item.id && this.state.program && this.state.program.id && Object.keys(updateObj).length > 0) {
        Firebase.database().ref('/sessions/' + parent + '/' + this.state.item.id + '/workout/' + this.state.program.id + '/blocks/' + block.id).update(updateObj);
      }
    }

    tmp++;
    this.setState({
      view: "select",
      timer: "getready",
      current: tmp,
      showOverlayNotes: false,
      program: program
    });
  }

  abortTimer() {
    clearInterval(this.counter);
    this.endTimer();
  }

  toggleAudio() {
    var tmp = true;
    if (this.state.volume === true) {
      tmp = false;
    }
    this.setState({
      volume: tmp,
    });
  }

  // Sets & Results ------------------------------------------------------------

  finishSet() {
    var block = this.state.program.blocks[this.state.current].data;
    if (block.rounds > 1 && this.state.round < block.rounds) {
      var tmp = this.state.round;
      tmp++;
      if (block.exWork[0] === 0) {
        this.setState({
          round: tmp,
        });
      } else {
        this.setState({
          pos: block.exWork[0],
          end: 0,
          timer: "rest",
          view: "timer",
          round: tmp,
        });
        this.counter = setInterval(this.count.bind(this), 1000);
      }
    } else {
      this.endTimer();
    }
  }

  showResults(index) {
    var block = this.state.program.blocks[index].data;
    var tmp3 = [];
    var tmp4 = [];

    var notesSimple = [];
    var ex = [];

    var valueSimple = [];
    var scaledSimple = [];

    var isGroup = this.state.item && this.state.item.data && this.state.item.data.group;
    var clientIdx = 0;
    if (isGroup && this.state.item.data.clients) {
      for (var ci = 0; ci < this.state.item.data.clients.length; ci++) {
        if (this.state.item.data.clients[ci] === global.spaceClient || this.state.item.data.clients[ci] === global.uidUser) {
          clientIdx = ci;
          break;
        }
      }
    }

    // Standard results
    if (!block.simple || block.simple === undefined) {
      for (var i = 0; i < block.exId.length; i++) {
        var e = {
          id: block.exId[i],
          name: block.exName[i],
          tool: block.exTool[i],
          base: block.exReps[i],
          reps: [],
          weight: [],
          repsr: [],
          weightr: [],
          weightType: block.exWeightType[i],
          weightp: block.exWeight[i],
        };

        var fallbackRepRounds = "0";
        if (block.exRepsRounds !== undefined && block.exRepsRounds.length > i && block.exRepsRounds[i] !== "") {
          fallbackRepRounds = block.exRepsRounds[i];
        }

        var fallbackWeightRounds = "0";
        if (block.exWeightRounds !== undefined && block.exWeightRounds.length > i && block.exWeightRounds[i] !== "" && block.exWeightRounds[i] !== "0") {
          fallbackWeightRounds = block.exWeightRounds[i];
        } else if (block.exWeight && block.exWeight.length > i && block.exWeight[i] !== 0) {
          fallbackWeightRounds = String(block.exWeight[i]);
        }

        if (isGroup) {
          // Reps
          if (block.exResRepsGroup && block.exResRepsGroup[i] !== undefined && block.exResRepsGroup[i] !== "") {
            var a1 = block.exResRepsGroup[i].split("-");
            e.reps.push((a1.length > clientIdx && a1[clientIdx] !== "") ? parseInt(a1[clientIdx]) : 0);
          } else {
            e.reps.push(0);
          }
          // Reps rounds
          if (block.exResRepsRounds && block.exResRepsRounds.length > i) {
            var a11 = block.exResRepsRounds[i].split("|");
            if (a11.length > clientIdx && a11[clientIdx] !== "" && a11[clientIdx] !== "0") {
              e.repsr.push(String(a11[clientIdx]));
            } else {
              e.repsr.push(fallbackRepRounds);
            }
          } else {
            e.repsr.push(fallbackRepRounds);
          }
          // Weight
          if (block.exResWeightGroup && block.exResWeightGroup[i] !== undefined && block.exResWeightGroup[i] !== "") {
            var a2 = block.exResWeightGroup[i].split("-");
            var defW = (block.exWeight && block.exWeight[i]) ? block.exWeight[i] : 0;
            e.weight.push((a2.length > clientIdx && a2[clientIdx] !== "") ? parseFloat(a2[clientIdx]) : defW);
          } else {
            e.weight.push((block.exWeight && block.exWeight[i]) ? block.exWeight[i] : 0);
          }
          // Weight rounds
          if (block.exResWeightRounds && block.exResWeightRounds.length > i) {
            var a21 = block.exResWeightRounds[i].split("|");
            if (a21.length > clientIdx && a21[clientIdx] !== "" && a21[clientIdx] !== "0") {
              e.weightr.push(String(a21[clientIdx]));
            } else {
              e.weightr.push(fallbackWeightRounds);
            }
          } else {
            e.weightr.push(fallbackWeightRounds);
          }
        } else {
          // 1:1 session
          if (block.exResReps && block.exResReps[i] !== undefined && block.exResReps[i] !== "") {
            e.reps.push(block.exResReps[i]);
          } else {
            e.reps.push(0);
          }
          if (block.exResRepsRounds && block.exResRepsRounds.length > i) {
            if (block.exResRepsRounds[i] !== undefined && block.exResRepsRounds[i] !== "" && block.exResRepsRounds[i] !== "0") {
              e.repsr.push(block.exResRepsRounds[i]);
            } else {
              e.repsr.push(fallbackRepRounds);
            }
          } else {
            e.repsr.push(fallbackRepRounds);
          }
          if (block.exResWeight && block.exResWeight[i] !== undefined && block.exResWeight[i] !== "") {
            e.weight.push(block.exResWeight[i]);
          } else {
            e.weight.push((block.exWeight && block.exWeight[i]) ? block.exWeight[i] : 0);
          }
          if (block.exResWeightRounds && block.exResWeightRounds.length > i) {
            if (block.exResWeightRounds[i] !== undefined && block.exResWeightRounds[i] !== "" && block.exResWeightRounds[i] !== "0") {
              e.weightr.push(block.exResWeightRounds[i]);
            } else {
              e.weightr.push(fallbackWeightRounds);
            }
          } else {
            e.weightr.push(fallbackWeightRounds);
          }
        }

        ex.push(e);
      }
    } else {
      // Simple results
      if (isGroup) {
        if (block.valueSimple && block.valueSimple.length > clientIdx) {
          valueSimple.push(block.valueSimple[clientIdx]);
        } else {
          valueSimple.push(0);
        }
        if (block.scaledSimple && block.scaledSimple.length > clientIdx) {
          scaledSimple.push(block.scaledSimple[clientIdx]);
        } else {
          scaledSimple.push(false);
        }
      } else {
        if (block.valueSimple && block.valueSimple.length > 0) {
          valueSimple = [block.valueSimple[0]];
        } else {
          valueSimple = [0];
        }
        if (block.scaledSimple && block.scaledSimple.length > 0) {
          scaledSimple = [block.scaledSimple[0]];
        } else {
          scaledSimple = [false];
        }
      }
    }

    if (block.type === 0) {
      if (!block.simple || block.simple === undefined) {
        var div = 0;
        for (var e1 of ex) {
          div += parseInt(e1.base) || 0;
        }
        var totalClientReps = 0;
        for (var exItem of ex) {
          totalClientReps += parseInt(exItem.reps[0]) || 0;
        }
        var t1 = div > 0 ? Math.floor(totalClientReps / div) : 0;
        var t2 = div > 0 ? totalClientReps - t1 * div : 0;
        tmp3.push(t1);
        tmp4.push(t2);
      } else {
        var aram = ["0", "0"];
        if (isGroup && block.amrapSimple && block.amrapSimple.length > clientIdx) {
          aram = String(block.amrapSimple[clientIdx] || "0+0").split("+");
        } else if (!isGroup && block.amrapSimple && block.amrapSimple.length > 0) {
          aram = String(block.amrapSimple[0] || "0+0").split("+");
        }
        tmp3.push(parseInt(aram[0]) || 0);
        tmp4.push(parseInt(aram[1]) || 0);
      }
    }

    if (block.type === 5) {
      tmp3 = [];
      tmp4 = [];
      var timeSec = 0;
      if (isGroup && block.timeResGroup && block.timeResGroup.length > clientIdx) {
        timeSec = parseInt(block.timeResGroup[clientIdx]) || 0;
      } else if (block.timeRes !== undefined) {
        timeSec = parseInt(block.timeRes) || 0;
      }
      var min1 = parseInt(Math.floor(timeSec / 60));
      var sec1 = timeSec - min1 * 60;
      tmp3.push(min1);
      tmp4.push(sec1);
    }

    if (isGroup) {
      if (block.notesResSimple !== undefined && block.notesResSimple !== "") {
        var arn = String(block.notesResSimple).split("|");
        var myNote = (arn.length > clientIdx && arn[clientIdx] !== "-") ? arn[clientIdx] : "";
        notesSimple.push(myNote);
      } else {
        notesSimple.push("");
      }
    } else {
      if (block.notesResSimple !== undefined && block.notesResSimple !== "" && block.notesResSimple !== "-") {
        notesSimple.push(block.notesResSimple);
      } else {
        notesSimple.push("");
      }
    }

    this.setState({
      view: "results",
      results: index,
      ex: ex,
      valAR1: tmp3,
      valAR2: tmp4,
      notes: block.notesRes,
      notesSimple: notesSimple,
      valueSimple: valueSimple,
      scaledSimple: scaledSimple,
    });
  }

  hideResults() {
    this.setState({
      view: "select",
    });
  }

  // Pause overlay ------------------------------------------------------------

  showOverlayPause() {
    this.setState({
      showOverlayPause: true,
      paused: true,
    });
    clearInterval(this.counter);
    setTimeout(() => {
      const height = this.divElement.clientHeight;
      this.setState({
        hiddenPause: "",
        margin: -height / 2,
      });
    }, 100);
  }

  hideOverlayPause() {
    const height = this.divElement.clientHeight;
    this.setState({
      hiddenPause: "hidden",
      paused: false,
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      this.setState({ showOverlayPause: false });
    }, 500);
  }

  renderOverlayPause() {
    if (this.state.showOverlayPause) {
      return (
        <div className={"overlay " + this.state.hiddenPause}>
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">{lang.t("modal:pause.title")}</h2>
            <p className="clear mb-30">{lang.t("modal:pause.text")}</p>
            <button
              className="btn primary"
              onClick={() => {
                this.hideOverlayPause();
                clearInterval(this.counter);
                this.counter = setInterval(this.count.bind(this), 1000);
              }}
            >
              {lang.t("modal:pause.button1")}
            </button>
            <div className="sv-20"></div>
            <button
              className="btn tertiary width-12"
              onClick={() => {
                this.hideOverlayPause();
                this.startTimer();
              }}
            >
              {lang.t("modal:pause.button2")}
            </button>
          </div>
        </div>
      );
    }
  }

  // Start and end session ------------------------------------------------------------

  endSession() {
    if (this.state.current < this.state.program.blocks.length) {
      this.showOverlayAbort();
    } else {
      this.showOverlayEnergy();
    }
  }

  showOverlayAbort() {
    this.setState({
      showOverlayAbort: true,
      paused: true,
    });
    clearInterval(this.counter);
    setTimeout(() => {
      const height = this.divElement.clientHeight;
      this.setState({
        hiddenAbort: "",
        margin: -height / 2,
      });
    }, 100);
  }

  hideOverlayAbort() {
    const height = this.divElement.clientHeight;
    if (this.state.status === "running" || this.state.status === "getready") {
      this.countTimer(this.state.time);
    }
    this.setState({
      hiddenAbort: "hidden",
      paused: false,
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      if (this.state.view === "timer") {
        this.counter = setInterval(this.count.bind(this), 1000);
      }

      this.setState({ showOverlayAbort: false });
    }, 500);
  }

  renderOverlayAbort() {
    if (this.state.showOverlayAbort) {
      return (
        <div className={"overlay " + this.state.hiddenAbort}>
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">{lang.t("modal:abort.title")}</h2>
            <button
              className="btn tertiary small close rgt"
              onClick={() => {
                this.hideOverlayAbort();
              }}
            >
              {lang.t("common:button.cancel")}
            </button>
            <p className="clear mb-30">{lang.t("modal:abort.text")}</p>
            <Link to={this.state.back} className="btn primary">
              {lang.t("modal:abort.button")}
            </Link>
          </div>
        </div>
      );
    }
  }

  showOverlayEnergy() {
    var energy = [];
    energy.push(0);
    this.setState({
      showOverlayEnergy: true,
      energyShown: true,
    });
    setTimeout(() => {
      const height = this.divElement.clientHeight;
      this.setState({
        hiddenEnergy: "",
        margin: -height / 2,
        energy: energy,
      });
    }, 100);
  }

  hideOverlayEnergy() {
    const height = this.divElement.clientHeight;
    this.setState({
      hiddenEnergy: "hidden",
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      this.setState({ showOverlayEnergy: false });
    }, 500);
  }

  renderOverlayEnergy() {
    if (this.state.showOverlayEnergy) {
      return (
        <div className={"overlay " + this.state.hiddenEnergy}>
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">{lang.t("modal:energy.title")}</h2>
            <button
              className="btn tertiary small close rgt"
              onClick={() => this.skipEnergy()}
            >
              {lang.t("modal:energy.skip")}
            </button>
            <p className="clear mb-20">
              {this.state.current === 0
                ? lang.t("modal:energy.text1")
                : lang.t("modal:energy.text2")}
            </p>
            <div className="radios">
              {this.state.levels.map((item, index) => (
                <button
                  className={
                    this.state.energy[0] === item
                      ? "radio col active"
                      : "radio col"
                  }
                  style={{ float: "left", width: "10%" }}
                  key={item}
                  onClick={() => this.setEnergy(item, 0)}
                >
                  {item}
                </button>
              ))}
            </div>
            <div className="sv-30"></div>
            <button className="btn primary" onClick={() => this.saveEnergy()}>
              {this.state.current === 0
                ? lang.t("modal:energy.button1")
                : lang.t("modal:energy.button2")}
            </button>
          </div>
        </div>
      );
    }
  }

  setEnergy(value, index) {
    var tmp = this.state.energy;
    tmp[index] = value;
    this.setState({
      energy: tmp,
    });
  }

  skipEnergy() {
    this.hideOverlayEnergy();
    if (this.state.current !== 0) {
      this.props.history.push(this.state.back);
    }
  }

  saveEnergy() {
    var label = "";
    for (var item of this.state.energy) {
      label += "-" + item;
    }
    var parent = global.uidUser;
    if (this.state.item && this.state.item.data) {
      if (this.state.item.data.businessUid) {
        parent = this.state.item.data.businessUid;
      } else if (this.state.item.data.uid && this.state.item.data.uid !== global.uidUser) {
        parent = this.state.item.data.uid;
      } else if (global.uid && global.sessions) {
        for (var gs of global.sessions) {
          if (gs.id === this.state.id) {
            parent = global.uid;
            break;
          }
        }
      }
    }
    if (this.state.current === 0) {
      Firebase.database()
        .ref("/sessions/" + parent + "/" + this.state.id)
        .update({
          energyStart: label,
        })
        .then((data) => {
          this.hideOverlayEnergy();
          EventEmitter.dispatch("showMessage", lang.t("message:energy"));
        })
        .catch((error) => {
          EventEmitter.dispatch("showMessageError", error.message);
        });
    } else {
      Firebase.database()
        .ref("/sessions/" + parent + "/" + this.state.id)
        .update({
          energyEnd: label,
        })
        .then((data) => {
          this.hideOverlayEnergy();
          global.message = lang.t("message:energy");
          this.props.history.push(this.state.back);
        })
        .catch((error) => {
          EventEmitter.dispatch("showMessageError", error.message);
        });
    }
  }

  showOverlayNotes() {
    this.setState({
      showOverlayNotes: true,
    });
  }

  hideOverlayNotes() {
    this.setState({
      showOverlayNotes: false,
    });
  }

  renderOverlayNotes() {
    if (this.state.showOverlayNotes) {
      return (
        <div className="run-onotes">
          <h2 className="mb-20 lft">{lang.t("training:label.notes")}</h2>
          <button
            className="btn tertiary small close rgt"
            onClick={() => {
              this.hideOverlayNotes();
            }}
          >
            {lang.t("modal:common.close")}
          </button>
          <p className="clear" style={{ whiteSpace: "pre-wrap" }}>
            {this.state.program.blocks[this.state.current].data.notes}
          </p>
          <div className="clear sv-20"></div>
        </div>
      );
    }
  }

  // Results stuff ------------------------------------------------------------

  renderSimpleValue(client) {
    if (
      this.state.program.blocks[this.state.results].data.type !== 0 &&
      this.state.program.blocks[this.state.results].data.type !== 5
    ) {
      return (
        <div className="item">
          <p className="title">
            <strong>Rounds and reps</strong>
          </p>
          <div className="first">
            <p>
              Result (
              {this.state.program.blocks[this.state.results].data.unitSimple ===
                undefined ||
              this.state.program.blocks[this.state.results].data.unitSimple ===
                ""
                ? "reps"
                : this.state.program.blocks[this.state.results].data.unitSimple}
              )
            </p>
            <input
              type="number"
              value={this.state.valueSimple[client]}
              onChange={(val) => this.onChangeSimpleValue(val, client)}
            />
          </div>
          <div className="clear"></div>
        </div>
      );
    }
  }

  renderExResult(client) {
    if (this.state.program.blocks[this.state.results].data.simple) {
      return (
        <div>
          {this.renderAmrap(client)}
          {this.renderTime(client)}
          {this.renderSimpleValue(client)}
        </div>
      );
    } else {
      return (
        <div>
          {this.renderAmrap(client)}
          {this.renderTime(client)}
          {this.state.program.blocks[this.state.results].data.exId.map(
            (item, index) => (
              <div key={index}>{this.renderExFields(index, client)}</div>
            ),
          )}
        </div>
      );
    }
  }

  renderAmrap(client) {
    if (this.state.program.blocks[this.state.results].data.type === 0) {
      return (
        <div className="item">
          <p className="title">
            <strong>{lang.t("training:running.roundsreps")}</strong>
          </p>
          <div className="first">
            <p>{lang.t("training:prog.rounds2")}</p>
            <input
              type="number"
              value={this.state.valAR1[client]}
              onChange={(val) => this.onChangeRoundsAR(val, client)}
            />
          </div>
          <div className="second">
            <p>{lang.t("training:label.reps")}</p>
            <input
              type="number"
              value={this.state.valAR2[client]}
              onChange={(val) => this.onChangeRepsAR(val, client)}
            />
          </div>
          <div className="clear"></div>
        </div>
      );
    }
  }

  renderTime(client) {
    if (this.state.program.blocks[this.state.results].data.type === 5) {
      return (
        <div className="item">
          <p className="title">
            <strong>{lang.t("training:label.completiontime")}</strong>
          </p>
          <div className="first">
            <p>{lang.t("training:running.minutes")}</p>
            <input
              type="number"
              value={this.state.valAR1[client]}
              onChange={(val) => this.onChangeMin(val, client)}
            />
          </div>
          <div className="second">
            <p>{lang.t("training:running.seconds")}</p>
            <input
              type="number"
              value={this.state.valAR2[client]}
              onChange={(val) => this.onChangeSec(val, client)}
            />
          </div>
          <div className="clear"></div>
        </div>
      );
    }
  }

  getFieldPlaceholder(index, type) {
    var label = "";
    var block = this.state.program.blocks[this.state.results];
    var cycles = 1;
    if (block.data.cycles !== undefined) {
      cycles = block.data.cycles;
    }
    if (
      ((block.data.type === 1 || block.data.type === 4) &&
        block.data.rounds > 1) ||
      (block.data.type === 5 && cycles > 1)
    ) {
      if (type === "reps") {
        label = lang.t("training:running.eg1");
      } else {
        label = lang.t("training:running.eg2");
      }
    }
    return label;
  }

  renderExRepsTitle(block, index) {
    var label = "Total reps";
    if (block.exUnits !== undefined) {
      if (block.exUnits.length > index) {
        if (block.exUnits[index] === "dist") {
          label = "Total distance (m)";
        }
        if (block.exUnits[index] === "cals") {
          label = "Total calories";
        }
        if (block.exUnits[index] === "time") {
          label = "Total time (s)";
        }
      }
    } else {
      if (
        block.exTool[index] === 6 ||
        block.exTool[index] === 7 ||
        block.exTool[index] === 25
      ) {
        label = "Total distance (m)";
      }
    }
    return label;
  }

  renderExFields(index, client) {
    var block = this.state.program.blocks[this.state.results].data;
    if (block.type === 0) {
      if (global.exToolsWeight.indexOf(block.exTool[index]) !== -1) {
        return (
          <div className="item">
            <p className="title">
              <strong>
                {block.exName[index]} {index}
              </strong>
            </p>
            <p>
              {lang.t("training:label.weightused")} ((
              {block.exWeightType[index] !== "per"
                ? block.exWeightType[index]
                : global.spaceLbs
                  ? "lb"
                  : "kg"}
              ))
            </p>
            <input
              type="text"
              value={this.state.ex[index].weightr[client]}
              onChange={(val) => this.onChangeWeight(val, index, client)}
            />
          </div>
        );
      }
    } else {
      if (
        block.exTool[index] === 0 ||
        block.exTool[index] === 6 ||
        block.exTool[index] === 7 ||
        block.exTool[index] === 9 ||
        block.exTool[index] === 11 ||
        block.exTool[index] === 25
      ) {
        return (
          <div className="item">
            <p className="title">
              <strong>
                {block.exName[index]} {index}
              </strong>
            </p>
            <p>{this.renderExRepsTitle(block, index)}</p>
            <input
              type="text"
              value={this.state.ex[index].repsr[client]}
              onChange={(val) => this.onChangeReps(val, index, client)}
              placeholder={this.getFieldPlaceholder(index, "reps")}
            />
          </div>
        );
      } else {
        return (
          <div className="item">
            <p className="title">
              <strong>{block.exName[index]}</strong>
            </p>
            <div className="first">
              <p>
                {this.renderExRepsTitle(block, index)} {index}
              </p>
              <input
                type="text"
                value={this.state.ex[index].repsr[client]}
                onChange={(val) => this.onChangeReps(val, index, client)}
                placeholder={this.getFieldPlaceholder(index, "reps")}
              />
            </div>
            <div className="second">
              <p>
                {lang.t("training:label.weightused")} ((
                {block.exWeightType[index] !== "per"
                  ? block.exWeightType[index]
                  : global.spaceLbs
                    ? "lb"
                    : "kg"}
                ))
              </p>
              <input
                type="text"
                value={this.state.ex[index].weightr[client]}
                onChange={(val) => this.onChangeWeight(val, index, client)}
                placeholder={this.getFieldPlaceholder(index, "weight")}
              />
            </div>
            <div className="clear"></div>
          </div>
        );
      }
    }
  }

  onChangeReps(event, index, client) {
    var ex = this.state.ex;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "0";
    if (tval === "") {
      tval = "0";
    }
    
    // Safely check if ex[index] exists
    if (!ex || !ex[index]) return;

    var val1 = tval.replace(/[,\s]+/g, "-").replace(/[^0-9-]/g, "");
    var val = val1.replace("--", "-");

    if (val.indexOf("-") !== -1) {
      var arv = val.split("-");
      var lv = 0;
      for (var av of arv) {
        if (av !== "" && !isNaN(parseInt(av))) {
          lv += parseInt(av);
        }
      }
      ex[index].reps[client] = parseInt(lv) || 0;
    } else {
      ex[index].reps[client] = parseInt(val) || 0;
    }
    ex[index].repsr[client] = val;

    this.setState({
      ex: ex,
    });
  }

  onChangeWeight(event, index, client) {
    var ex = this.state.ex;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "0";
    if (tval === "") {
      tval = "0";
    }
    
    // Safely check if ex[index] exists
    if (!ex || !ex[index]) return;

    var val1 = tval.replace(/[,\s]+/g, "-").replace(/[^0-9-]/g, "");
    var val = val1.replace("--", "-");

    if (val.indexOf("-") !== -1) {
      var arv = val.split("-");
      var lv = 0;
      for (var av of arv) {
        if (av !== "" && !isNaN(parseFloat(av))) {
          if (parseFloat(av) > lv) {
            lv = parseFloat(av);
          }
        }
      }
      ex[index].weight[client] = parseFloat(lv) || 0;
    } else {
      ex[index].weight[client] = parseFloat(val) || 0;
    }
    ex[index].weightr[client] = val;

    this.setState({
      ex: ex,
    });
  }

  onChangeRoundsAR(event, client) {
    var tmp = this.state.valAR1;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "0";
    if (tval === "") {
      tval = "0";
    }
    var parsedVal = parseInt(tval) || 0;
    var clientIdx = this.state.item && this.state.item.data && this.state.item.data.group ? client : 0;
    tmp[clientIdx] = parsedVal;
    
    var curReps = this.state.valAR2 && this.state.valAR2[clientIdx] !== undefined ? this.state.valAR2[clientIdx] : 0;
    if (
      !this.state.program.blocks[this.state.results].data.simple ||
      this.state.program.blocks[this.state.results].data.simple === undefined
    ) {
      if (this.state.program.blocks[this.state.results].data.type === 0) {
        this.setAmrap(parsedVal, curReps, clientIdx);
      }
    }

    this.setState({
      valAR1: tmp,
    });
  }

  onChangeRepsAR(event, client) {
    var tmp = this.state.valAR2;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "0";
    if (tval === "") {
      tval = "0";
    }
    var parsedVal = parseInt(tval) || 0;
    var clientIdx = this.state.item && this.state.item.data && this.state.item.data.group ? client : 0;
    tmp[clientIdx] = parsedVal;

    var curRounds = this.state.valAR1 && this.state.valAR1[clientIdx] !== undefined ? this.state.valAR1[clientIdx] : 0;
    if (
      !this.state.program.blocks[this.state.results].data.simple ||
      this.state.program.blocks[this.state.results].data.simple === undefined
    ) {
      if (this.state.program.blocks[this.state.results].data.type === 0) {
        this.setAmrap(curRounds, parsedVal, clientIdx);
      }
    }
    this.setState({
      valAR2: tmp,
    });
  }

  setAmrap(rounds, rps, client) {
    var ex = this.state.ex;
    var reps = parseInt(rps) || 0;
    var max = 0;
    for (var e1 of this.state.ex) {
      max += (e1.base || 0);
      if (!e1.reps) e1.reps = [];
      e1.reps[client] = 0;
    }
    var loop = max > 0 ? Math.ceil(reps / max) : 0;
    if (loop > 0) {
      for (var i = 0; i < loop; i++) {
        for (var e2 of ex) {
          if (reps > e2.base) {
            e2.reps[client] += e2.base;
            reps -= e2.base;
          } else {
            if (reps > 0) {
              e2.reps[client] += reps;
              reps = 0;
            }
          }
        }
      }
    }
    for (var e3 of this.state.ex) {
      e3.reps[client] += (parseInt(rounds) || 0) * (e3.base || 0);
    }
    this.setState({
      ex: ex,
    });
  }

  onChangeMin(event, client) {
    var tmp = this.state.valAR1;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "0";
    if (tval === "") {
      tval = "0";
    }
    tmp[0] = parseInt(tval) || 0;

    this.setState({
      valAR1: tmp,
    });
  }

  onChangeSec(event, client) {
    var tmp = this.state.valAR2;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "0";
    if (tval === "") {
      tval = "0";
    }
    tmp[0] = parseInt(tval) || 0;

    this.setState({
      valAR2: tmp,
    });
  }

  onChangeSimple(event, index) {
    var tmp = this.state.notesSimple;
    tmp[index] = event;
    this.setState({
      notesSimple: tmp,
    });
  }

  onChangeSimpleValue(event, index) {
    var tmp = this.state.valueSimple;
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "";
    tmp[index] = tval;
    this.setState({
      valueSimple: tmp,
    });
  }

  updateScaled(value, index) {
    var tmp = this.state.scaledSimple;
    tmp[index] = value;
    this.setState({
      scaledSimple: tmp,
    });
  }

  onChangeNotes(event) {
    var rawVal = event && event.target ? event.target.value : event;
    var tval = rawVal !== undefined && rawVal !== null ? rawVal.toString() : "";
    this.setState({
      notes: tval,
    });
  }

  saveResults() {
    var block = this.state.program.blocks[this.state.results];
    var reps = [];
    var repsr = [];
    var weight = [];
    var weightr = [];

    var parent = global.uidUser;
    if (this.state.item && this.state.item.data) {
      if (this.state.item.data.businessUid) {
        parent = this.state.item.data.businessUid;
      } else if (this.state.item.data.uid && this.state.item.data.uid !== global.uidUser) {
        parent = this.state.item.data.uid;
      } else if (global.uid && global.sessions) {
        for (var gs of global.sessions) {
          if (gs.id === this.state.item.id) {
            parent = global.uid;
            break;
          }
        }
      }
    }

    var clientIdx = 0;
    var isGroup = this.state.item && this.state.item.data && this.state.item.data.group;
    var numClients = isGroup && this.state.item.data.clients ? this.state.item.data.clients.length : 1;
    if (isGroup && this.state.item.data.clients) {
      for (var ci = 0; ci < this.state.item.data.clients.length; ci++) {
        if (this.state.item.data.clients[ci] === global.spaceClient || this.state.item.data.clients[ci] === global.uidUser) {
          clientIdx = ci;
          break;
        }
      }
    }

    // Simple results
    if (block.data.simple) {
      var tmp1 = [...this.state.valueSimple];
      for (var i1 = 0; i1 < tmp1.length; i1++) {
        if (tmp1[i1] === "" || tmp1[i1] === undefined || isNaN(parseFloat(tmp1[i1]))) {
          tmp1[i1] = 0;
        } else {
          tmp1[i1] = parseFloat(tmp1[i1]);
        }
      }

      var notess = "";
      for (var note of this.state.notesSimple) {
        if (note !== "") {
          notess += "|" + note;
        } else {
          notess += "|-";
        }
      }
      notess = notess.substring(1);

      var times2 = 0;
      var amrap2 = [];
      if (block.data.type === 5) {
        var minVal = this.state.valAR1[clientIdx] || this.state.valAR1[0] || "";
        var secVal = this.state.valAR2[clientIdx] || this.state.valAR2[0] || "";
        if (minVal !== "") {
          times2 += parseInt(minVal) * 60;
        }
        if (secVal !== "") {
          times2 += parseInt(secVal);
        }
      }
      if (block.data.type === 0) {
        var alabel2 = "";
        var rndVal = this.state.valAR1[clientIdx] !== undefined ? this.state.valAR1[clientIdx] : (this.state.valAR1[0] || "");
        var repVal = this.state.valAR2[clientIdx] !== undefined ? this.state.valAR2[clientIdx] : (this.state.valAR2[0] || "");
        if (rndVal !== "") {
          alabel2 = rndVal + "+";
        } else {
          alabel2 = "0+";
        }
        if (repVal !== "") {
          alabel2 += repVal;
        } else {
          alabel2 += "0";
        }
        amrap2.push(alabel2);
      }

      var updatePayload = {};
      if (isGroup) {
        var currentValArr = Array.isArray(block.data.valueSimple) ? [...block.data.valueSimple] : [];
        while (currentValArr.length < numClients) {
          currentValArr.push(0);
        }
        currentValArr[clientIdx] = tmp1[clientIdx] !== undefined ? tmp1[clientIdx] : (tmp1[0] || 0);

        var currentAmrapArr = Array.isArray(block.data.amrapSimple) ? [...block.data.amrapSimple] : [];
        while (currentAmrapArr.length < numClients) {
          currentAmrapArr.push("0+0");
        }
        if (amrap2.length > 0) {
          currentAmrapArr[clientIdx] = amrap2[0];
        }

        var currentScaledArr = Array.isArray(block.data.scaledSimple) ? [...block.data.scaledSimple] : [];
        while (currentScaledArr.length < numClients) {
          currentScaledArr.push(false);
        }
        currentScaledArr[clientIdx] = this.state.scaledSimple[clientIdx] !== undefined ? this.state.scaledSimple[clientIdx] : (this.state.scaledSimple[0] || false);

        var existingNotes = (block.data.notesResSimple || "").split("|");
        while (existingNotes.length < numClients) {
          existingNotes.push("-");
        }
        var myNote = this.state.notesSimple[clientIdx] || this.state.notesSimple[0] || "-";
        existingNotes[clientIdx] = myNote !== "" ? myNote : "-";
        var mergedNotes = existingNotes.join("|");

        var currentTimeArr = Array.isArray(block.data.timeResGroup) ? [...block.data.timeResGroup] : [];
        while (currentTimeArr.length < numClients) {
          currentTimeArr.push(0);
        }
        currentTimeArr[clientIdx] = times2;

        updatePayload = {
          valueSimple: currentValArr,
          scaledSimple: currentScaledArr,
          amrapSimple: currentAmrapArr,
          timeRes: times2,
          timeResGroup: currentTimeArr,
          notesResSimple: mergedNotes,
        };

        block.data.valueSimple = currentValArr;
        block.data.scaledSimple = currentScaledArr;
        block.data.amrapSimple = currentAmrapArr;
        block.data.timeRes = times2;
        block.data.timeResGroup = currentTimeArr;
        block.data.notesResSimple = mergedNotes;
      } else {
        updatePayload = {
          valueSimple: tmp1,
          scaledSimple: this.state.scaledSimple,
          amrapSimple: amrap2,
          timeRes: times2,
          notesResSimple: notess,
        };

        block.data.valueSimple = tmp1;
        block.data.scaledSimple = this.state.scaledSimple;
        block.data.amrapSimple = amrap2;
        block.data.timeRes = times2;
        block.data.notesResSimple = notess;
      }

      Firebase.database()
        .ref(
          "/sessions/" +
            parent +
            "/" +
            this.state.item.id +
            "/workout/" +
            this.state.program.id +
            "/blocks/" +
            block.id,
        )
        .update(updatePayload);

      var tmb2 = this.state.program.blocks;
      tmb2[this.state.results] = block;
      // Standard results
    } else {
      var time2 = 0;
      if (block.data.type === 5) {
        var minVal = this.state.valAR1[clientIdx] || this.state.valAR1[0] || "";
        var secVal = this.state.valAR2[clientIdx] || this.state.valAR2[0] || "";
        if (minVal !== "") {
          time2 += parseInt(minVal) * 60;
        }
        if (secVal !== "") {
          time2 += parseInt(secVal);
        }
      }
      for (var ex of this.state.ex) {
        var myRep = (ex.reps && ex.reps[clientIdx] !== undefined) ? ex.reps[clientIdx] : (ex.reps && ex.reps[0] !== undefined ? ex.reps[0] : 0);
        var myRepR = (ex.repsr && ex.repsr[clientIdx] !== undefined) ? ex.repsr[clientIdx] : (ex.repsr && ex.repsr[0] !== undefined ? ex.repsr[0] : "0");
        var myWeight = (ex.weight && ex.weight[clientIdx] !== undefined) ? ex.weight[clientIdx] : (ex.weight && ex.weight[0] !== undefined ? ex.weight[0] : 0);
        var myWeightR = (ex.weightr && ex.weightr[clientIdx] !== undefined) ? ex.weightr[clientIdx] : (ex.weightr && ex.weightr[0] !== undefined ? ex.weightr[0] : "0");
        reps.push(myRep);
        repsr.push(myRepR);
        weight.push(myWeight);
        weightr.push(myWeightR);
        this.updateBest(ex);
      }

      var memberNoteStd = this.state.notesSimple[0] || this.state.notes || "";
      var updatePayloadStd = {
        exResReps: reps,
        exResWeight: weight,
        timeRes: time2,
      };

      if (isGroup) {
        var repsGroup = [];
        var weightGroup = [];
        var repsRoundsGroup = [];
        var weightRoundsGroup = [];

        for (var ei = 0; ei < this.state.ex.length; ei++) {
          var curRepsGroupStr = (block.data.exResRepsGroup && block.data.exResRepsGroup[ei]) ? block.data.exResRepsGroup[ei] : "";
          var curWeightGroupStr = (block.data.exResWeightGroup && block.data.exResWeightGroup[ei]) ? block.data.exResWeightGroup[ei] : "";
          var rParts = curRepsGroupStr ? curRepsGroupStr.split("-") : [];
          var wParts = curWeightGroupStr ? curWeightGroupStr.split("-") : [];
          while (rParts.length < numClients) rParts.push("0");
          while (wParts.length < numClients) wParts.push("0");
          rParts[clientIdx] = reps[ei].toString();
          wParts[clientIdx] = weight[ei].toString();
          repsGroup.push(rParts.join("-"));
          weightGroup.push(wParts.join("-"));

          var curRepsRoundsStr = (block.data.exResRepsRounds && block.data.exResRepsRounds[ei]) ? String(block.data.exResRepsRounds[ei]) : "";
          var curWeightRoundsStr = (block.data.exResWeightRounds && block.data.exResWeightRounds[ei]) ? String(block.data.exResWeightRounds[ei]) : "";
          var rRoundParts = [];
          var wRoundParts = [];
          if (curRepsRoundsStr) {
            var rawRP = curRepsRoundsStr.split("|");
            for (var c = 0; c < numClients; c++) {
              rRoundParts.push(rawRP[c] !== undefined && rawRP[c] !== "" ? rawRP[c] : "0");
            }
          } else {
            for (var c = 0; c < numClients; c++) rRoundParts.push("0");
          }
          if (curWeightRoundsStr) {
            var rawWP = curWeightRoundsStr.split("|");
            for (var c = 0; c < numClients; c++) {
              wRoundParts.push(rawWP[c] !== undefined && rawWP[c] !== "" ? rawWP[c] : "0");
            }
          } else {
            for (var c = 0; c < numClients; c++) wRoundParts.push("0");
          }
          rRoundParts[clientIdx] = repsr[ei].toString();
          wRoundParts[clientIdx] = weightr[ei].toString();
          repsRoundsGroup.push(rRoundParts.join("|") + "|");
          weightRoundsGroup.push(wRoundParts.join("|") + "|");
        }

        var existingNotesStd = (block.data.notesResSimple || "").split("|");
        while (existingNotesStd.length < numClients) {
          existingNotesStd.push("-");
        }
        existingNotesStd[clientIdx] = memberNoteStd !== "" ? memberNoteStd : "-";
        var mergedNotesStd = existingNotesStd.join("|");

        updatePayloadStd.exResRepsGroup = repsGroup;
        updatePayloadStd.exResWeightGroup = weightGroup;
        updatePayloadStd.exResRepsRounds = repsRoundsGroup;
        updatePayloadStd.exResWeightRounds = weightRoundsGroup;
        updatePayloadStd.notesResSimple = mergedNotesStd;

        if (block.data.type === 5) {
          var currentTimeArr = Array.isArray(block.data.timeResGroup) ? [...block.data.timeResGroup] : [];
          while (currentTimeArr.length < numClients) {
            currentTimeArr.push(0);
          }
          currentTimeArr[clientIdx] = time2;
          updatePayloadStd.timeResGroup = currentTimeArr;
          block.data.timeResGroup = currentTimeArr;
        }

        block.data.exResRepsGroup = repsGroup;
        block.data.exResWeightGroup = weightGroup;
        block.data.exResRepsRounds = repsRoundsGroup;
        block.data.exResWeightRounds = weightRoundsGroup;
        block.data.notesResSimple = mergedNotesStd;
      } else {
        updatePayloadStd.exResRepsRounds = repsr;
        updatePayloadStd.exResWeightRounds = weightr;
        updatePayloadStd.notesResSimple = memberNoteStd;

        block.data.exResRepsRounds = repsr;
        block.data.exResWeightRounds = weightr;
        block.data.notesResSimple = memberNoteStd;
      }

      block.data.exResReps = reps;
      block.data.exResWeight = weight;
      block.data.timeRes = time2;

      var tmb2 = this.state.program.blocks;
      tmb2[this.state.results] = block;

      Firebase.database()
        .ref(
          "/sessions/" +
            parent +
            "/" +
            this.state.item.id +
            "/workout/" +
            this.state.program.id +
            "/blocks/" +
            block.id,
        )
        .update(updatePayloadStd);
    }
    
    var updatedProgram = this.state.program;
    this.setState({ program: updatedProgram });

    this.hideResults();
    EventEmitter.dispatch("showMessage", lang.t("message:results"));
  }

  updateBest(ex) {
    var update = true;
    var final = 0;
    var actual = 0;
    var weight = 0;
    var tmp = this.state.best;
    var type = "kg";
    if (global.spaceLbs) {
      type = "lb";
    }
    if (ex.weightType !== "per") {
      type = ex.weightType;
    }

    final = parseFloat(ex.weight);
    actual = parseFloat(ex.weight);
    weight = parseFloat(ex.weight);

    var per = 0;
    //for(var item of global.clientBest) {
    for (var item of tmp) {
      if (item.id === ex.id) {
        if (ex.tool !== 6 && ex.tool !== 7) {
          if (ex.weightp > 0 && ex.weightType === "per") {
            final = weight * (100 / ex.weightp);
            per = ex.weightp;
          }

          var rval = item.data.value;
          var rtype = "";
          if (item.data.type !== undefined) {
            rtype = item.data.type;
          }
          if (
            (rtype === "kg" && ex.weightType === "lb") ||
            (rtype === "kg" && ex.weightType === "per" && global.spaceLbs)
          ) {
            rval = item.data.value * global.lbsUp;
          }
          if (
            (rtype === "lb" && ex.weightType === "kg") ||
            (rtype === "lb" && ex.weightType === "per" && !global.spaceLbs)
          ) {
            rval = item.data.value * global.lbsDown;
          }
          if (rval > final) {
            update = false;
          }
        }
        if (item.data.value < weight && (ex.tool === 6 || ex.tool === 7)) {
          update = false;
        }
        if (update) {
          item.data.value = final;
          item.data.type = type;
          this.setState({
            best: tmp,
          });
        }
      }
    }

    if (final === 0) {
      update = false;
    }

    var unit = "";
    if (ex.unit !== undefined) {
      unit = ex.unit;
    }
    if (update && ex.tool !== 0 && ex.tool !== 9) {
      if (final > 0) {
        Firebase.database()
          .ref("/records/" + global.uidUser + "/" + ex.id)
          .update({
            date: Moment(this.state.item.data.date, "DD/MM/YYYY HH:mm").format(
              "DD/MM/YYYY HH:mm",
            ),
            id: ex.id,
            name: ex.name,
            tool: ex.tool,
            value: final,
            actual: actual,
            percent: per,
            unit: unit,
            type: type,
          });
      }
    }
  }

  // Display stuff ------------------------------------------------------------

  renderExNotes(item, index) {
    if (item.data.exNotes !== undefined) {
      if (item.data.exNotes[index] !== undefined) {
        return (
          <span>
            <br />
            {item.data.exNotes[index]}
          </span>
        );
      }
    }
  }

  renderExBlock(block) {
    if (block.data.simple) {
      return (
        <div
          className={
            block === this.state.program.blocks[this.state.current]
              ? "none"
              : ""
          }
        >
          <p className="mnotes" style={{ opacity: 0.3 }}>
            {block.data.notes}
          </p>
        </div>
      );
    } else {
      return (
        <div>
          {block.data.exName.map((item, index) => (
            <div className="item" key={index}>
              <strong>{item}</strong>
              <br />
              {this.getExInfo(block, index)}
              {this.getInterval(block, index)}
              {this.renderExNotes(block, index)}
            </div>
          ))}
        </div>
      );
    }
  }

  renderExOpacity(index) {
    var opacity = 1;
    var block = this.state.program.blocks[this.state.current].data;
    if (block.type === 1 && !block.emom && index !== this.state.interval) {
      opacity = 0.4;
    } else if (
      block.type === 2 &&
      !block.emom &&
      index !== this.state.interval
    ) {
      opacity = 0.4;
    } else if (block.type === 3) {
    }
    return opacity;
  }

  renderResultButton(index) {
    if (this.state.program.blocks[index].data.logResults !== false) {
      return (
        <button
          className="btn tertiary width-12"
          onClick={() => this.showResults(index)}
        >
          {lang.t("training:button.editresults")}
        </button>
      );
    }
  }

  renderCurrentNotes() {
    if (this.state.program.blocks[this.state.current].data.notes !== "") {
      return (
        <p className="mnotes">
          {this.state.program.blocks[this.state.current].data.notes}
        </p>
      );
    }
  }

  renderCurrentBlockTitle() {
    let item = this.state.program.blocks[this.state.current];
    if (item.data.name !== "" && item.data.name !== undefined) {
      return item.data.name;
    } else {
      return lang.t(global.exCats[item.data.cat]);
    }
  }

  renderCurrent() {
    if (this.state.current < this.state.program.blocks.length) {
      return (
        <div className="block">
          <div className="run-bar">{this.renderCurrentBlockTitle()}</div>
          <h2>
            {this.getBlockHeader(this.state.program.blocks[this.state.current])}
          </h2>
          <div className="main">
            {this.renderExBlock(this.state.program.blocks[this.state.current])}
            {this.renderCurrentNotes()}
          </div>
          <div className="cbutton">
            <button className="btn primary" onClick={() => this.startTimer()}>
              {lang.t("training:button.start")}
            </button>
          </div>
        </div>
      );
    }
  }

  renderBlockTitle(item) {
    if (item.data.name !== "" && item.data.name !== undefined) {
      return item.data.name;
    } else {
      return lang.t(global.exCats[item.data.cat]);
    }
  }

  renderBlocks() {
    if (this.state.view === "select" && this.state.item !== null) {
      var list1 = [];
      var list2 = [];
      for (var i = 0; i < this.state.program.blocks.length; i++) {
        if (i < this.state.current) {
          list1.push(this.state.program.blocks[i]);
        }
        if (i > this.state.current) {
          list2.push(this.state.program.blocks[i]);
        }
      }
      return (
        <div className="run-blocks">
          <div
            style={{
              height: "400px",
              width: this.state.program.blocks.length * 300,
              display: "inline-block",
            }}
          >
            {list1.map((item, index) => (
              <div className="block done" key={index}>
                <div className="run-bar">{this.renderBlockTitle(item)}</div>
                <h2>{this.getBlockHeader(item)}</h2>
                <div className="main">{this.renderExBlock(item)}</div>
                {this.renderResultButton(index)}
              </div>
            ))}
            {this.renderCurrent()}
            {list2.map((item, index) => (
              <div className="block upcoming" key={index}>
                <div className="run-bar">{this.renderBlockTitle(item)}</div>
                <h2>{this.getBlockHeader(item)}</h2>
                <div className="main">{this.renderExBlock(item)}</div>
              </div>
            ))}
          </div>
        </div>
      );
    }
  }

  renderTimer() {
    if (this.state.view === "timer") {
      return (
        <div className="run-timer">
          <h3 className={this.state.timer}>{this.getTimerName()}</h3>
          <h2>{this.displayTimer()}</h2>
        </div>
      );
    }
  }

  renderSetsTitle() {
    if (this.state.program.blocks[this.state.current].data.rounds > 1) {
      return (
        <h3>
          {lang.t("training:prog.set2")} {this.state.round}
        </h3>
      );
    }
  }

  renderSets() {
    console.log("render sets =>", this.state);
    if (this.state.view === "sets") {
      if (this.state.program.blocks[this.state.current].data.simple) {
        return (
          <div>
            <div className="sets">
              {this.renderSetsTitle()}
              {this.state.program.blocks[this.state.current].data.exName.map(
                (item, index) => (
                  <div
                    className="item"
                    key={index}
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    {this.state.program.blocks[this.state.current].data.notes}
                  </div>
                ),
              )}
            </div>
            <div className="btn-sets">
              <button className="btn primary" onClick={() => this.finishSet()}>
                Finish set
              </button>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div className="sets">
              {this.renderSetsTitle()}
              {this.state.program.blocks[this.state.current].data.exName.map(
                (item, index) => (
                  <div
                    className={
                      this.state.program.blocks[this.state.current].data.simple
                        ? "none"
                        : "item"
                    }
                    key={index}
                  >
                    <strong>{item}</strong>
                    <br />
                    {this.getExInfo(
                      this.state.program.blocks[this.state.current],
                      index,
                    )}
                    {this.renderExNotes(
                      this.state.program.blocks[this.state.current],
                      index,
                    )}
                  </div>
                ),
              )}
            </div>
            <div className="btn-sets">
              <button className="btn primary" onClick={() => this.finishSet()}>
                {lang.t("training:button.finishset")}
              </button>
            </div>
          </div>
        );
      }
    }
  }

  renderScaled(index) {
    if (this.state.program.blocks[this.state.results].data.simple) {
      return (
        <InputToggle
          label={"Scaled"}
          value={this.state.scaledSimple[index]}
          onChange={(event) => this.updateScaled(event, index)}
          text={"Completed scaled"}
        />
      );
    }
  }

  renderResults() {
    if (this.state.view === "results") {
      return (
        <div>
          <div className="run-blocks">
            <div
              style={{ height: "400px", width: 300, display: "inline-block" }}
            >
              <div className="block result">
                <div className="client small static">
                  {HelperClients.getImage(this.getClient(global.spaceClient))}
                  <div className="text">
                    {lang.t("training:running.yourresults")}
                  </div>
                </div>
                <div className="movements clear">
                  {this.renderExResult(0)}
                  <div className="item">
                    {this.renderScaled(0)}
                    <Textarea
                      label={"Notes"}
                      value={this.state.notesSimple[0]}
                      onChange={(event) => this.onChangeSimple(event, 0)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="run-notes none">
            <h3>{lang.t("training:label.notes")}</h3>
            <textarea
              value={this.state.notes}
              onChange={(val) => this.onChangeNotes(val)}
            />
          </div>
          <div className="btn-sets">
            <button className="btn primary" onClick={() => this.saveResults()}>
              {lang.t("training:button.saveresults")}
            </button>
            <div className="sv-30 clear"></div>
            <button
              className="btn tertiary width-12 close"
              onClick={() => this.hideResults()}
            >
              {lang.t("common:button.cancel")}
            </button>
          </div>
        </div>
      );
    }
  }

  renderList() {
    if (this.state.item !== null) {
      if (
        this.state.view === "timer" &&
        this.state.timer !== "getready" &&
        this.state.program.blocks[this.state.current].data.type !== 4
      ) {
        if (this.state.program.blocks[this.state.current].data.simple) {
          return (
            <div className="run-sidebar">
              <div className="list bare static">
                <h4 style={{ whiteSpace: "pre-wrap" }}>
                  {this.state.program.blocks[this.state.current].data.notes}
                </h4>
              </div>
            </div>
          );
        } else {
          return (
            <div
              className={
                this.state.program.blocks[this.state.current].data.simple ===
                undefined
                  ? "run-sidebar"
                  : "none"
              }
            >
              <h4 className="mb-20">{lang.t("training:label.movements2")}</h4>
              {this.state.program.blocks[this.state.current].data.exName.map(
                (item, index) => (
                  <div
                    className="list bare static"
                    style={{ opacity: this.renderExOpacity(index) }}
                    key={index}
                  >
                    <h4>{item}</h4>
                    <div
                      className="main"
                      style={{ width: "100%", float: "none" }}
                    >
                      <p>
                        {this.getExInfo(
                          this.state.program.blocks[this.state.current],
                          index,
                        )}
                        {this.renderExNotes(
                          this.state.program.blocks[this.state.current],
                          index,
                        )}
                      </p>
                      <div className="clear"></div>
                    </div>
                  </div>
                ),
              )}
            </div>
          );
        }
      }
    }
  }

  renderCurrentBlock() {
    if (this.state.view === "timer") {
      var block = this.state.program.blocks[this.state.current].data;
      if (block.type === 0 || block.type === 5) {
        return (
          <h2>
            {this.getBlockHeader(this.state.program.blocks[this.state.current])}
          </h2>
        );
      } else {
        if (block.type === 1) {
          if (block.rounds > 1) {
            return (
              <h2>
                {lang.t("training:running.emom")} (
                {HelperCal.getDurationMinAlt(parseInt(block.exWork[0]))}) -{" "}
                {lang.t("training:running.round")} {this.state.round}{" "}
                {lang.t("training:prog.of")} {block.rounds}
              </h2>
            );
          } else {
            return (
              <h2>
                {lang.t("training:running.emom")} (
                {HelperCal.getDurationMinAlt(parseInt(block.exWork[0]))})
              </h2>
            );
          }
        } else if (block.type === 2) {
          if (block.emom) {
            return (
              <h2>
                {lang.t("training:running.intervals1")} (
                {HelperCal.getDurationMinAlt(parseInt(block.exWork[0]))} /{" "}
                {HelperCal.getDurationMinAlt(parseInt(block.exRest[0]))}) -
                Round {this.state.round} {lang.t("training:prog.of")}{" "}
                {block.rounds}
              </h2>
            );
          } else {
            return (
              <h2>
                {lang.t("training:running.intervals2")} {this.state.round} of{" "}
                {block.rounds}
              </h2>
            );
          }
        } else if (block.type === 3) {
          if (block.rounds > 1) {
            return (
              <h2>
                {lang.t("training:running.tabata")} {this.state.round}{" "}
                {lang.t("training:prog.of")} {block.rounds}
              </h2>
            );
          } else {
            return (
              <h2>
                {this.getBlockHeader(
                  this.state.program.blocks[this.state.current],
                )}
              </h2>
            );
          }
        }
      }
    } else if (this.state.view === "sets") {
      return (
        <h2>
          {this.getBlockHeader(this.state.program.blocks[this.state.current])}
        </h2>
      );
    } else if (this.state.view === "results") {
      return (
        <h2>
          {lang.t("training:running.results")}{" "}
          {this.getBlockHeader(this.state.program.blocks[this.state.results])}
        </h2>
      );
    }
  }

  renderButtonNotes() {
    if (
      this.state.program.blocks[this.state.current].data.notes !== "" &&
      (!this.state.program.blocks[this.state.current].data.simple ||
        this.state.program.blocks[this.state.current].data.simple === undefined)
    ) {
      return (
        <button
          className="btn bnotes"
          onClick={() => this.showOverlayNotes()}
        ></button>
      );
    }
  }

  renderButtons() {
    if (this.state.view === "select" || this.state.view === "results") {
      return (
        <div className="run-buttons">
          <button
            className={this.state.volume ? "btn audio-on" : "btn audio-off"}
            onClick={() => this.toggleAudio()}
          ></button>
        </div>
      );
    } else if (this.state.view === "sets") {
      return (
        <div className="run-buttons">
          <button
            className={this.state.volume ? "btn audio-on" : "btn audio-off"}
            onClick={() => this.toggleAudio()}
          ></button>
          <button
            className="btn next"
            onClick={() => this.abortTimer()}
          ></button>
          {this.renderButtonNotes()}
        </div>
      );
    } else {
      return (
        <div className="run-buttons">
          <button
            className={this.state.volume ? "btn audio-on" : "btn audio-off"}
            onClick={() => this.toggleAudio()}
          ></button>
          <button
            className="btn next"
            onClick={() => this.abortTimer()}
          ></button>
          <button
            className="btn pause"
            onClick={() => this.showOverlayPause()}
          ></button>
          {this.renderButtonNotes()}
        </div>
      );
    }
  }

  renderBase() {
    if (this.state.item !== null && this.state.program !== null) {
      return (
        <div className={"run theme-" + global.spaceTheme}>
          {this.renderBlocks()}
          {this.renderTimer()}
          {this.renderSets()}
          {this.renderResults()}
          {this.renderList()}
          <div className="header">
            <div className="content">
              <div className="back lft mr-10" onClick={() => this.endSession()}>
                <div className="circle"></div>
                <div className="arrow"></div>
              </div>
              <h2>{this.getSessionName()}</h2>
            </div>
          </div>
          {this.renderButtons()}
          <div className="run-blocktitle">{this.renderCurrentBlock()}</div>
          <Message />
          {this.renderOverlayPause()}
          {this.renderOverlayAbort()}
          {this.renderOverlayEnergy()}
          {this.renderOverlayNotes()}
        </div>
      );
    } else {
      return (
        <div className={"run theme-" + global.spaceTheme}>
          <div className="header">
            <button className="back" onClick={() => this.endSession()}></button>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => this.renderBase()}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = (authUser) => !!authUser;
export default withTranslation([
  "header",
  "common",
  "calendar",
  "modal",
  "training",
  "message",
])(withRouter(withAuthorization(condition)(MemberRunningPage)));
